<template>
  <mds-button-container class="custom-table__actions">
    <mds-button
      v-for="(action, key) in actions"
      :key="key"
      :icon="action.icon"
      variation="flat"
      size="small"
      class="custom-table__action"
      :id="triggerName"
      @mouseover="toggleTooltip(rowId, action.event, true)"
      @mouseleave="toggleTooltip(rowId, action.event, false)"
      @focus="toggleTooltip(rowId, action.event, true)"
      @blur="toggleTooltip(rowId, action.event, false)"
      @click.native="triggerEvent(action.event, $event)"
    >
      {{ translate(action.name) }}
      <mds-tooltip
        v-if="action.event === exportEvent"
        :triggered-by="triggerName"
        :position="['bottom-left']"
        size="small"
        class="export-label__tooltip"
        v-model="tooltipStates[rowId]"
      >
        {{ translate('table.export.tooltip.text') }}
      </mds-tooltip>
    </mds-button>
    <CustomTablePopover :rowId="rowId" :record="record" v-on="$listeners" />
  </mds-button-container>
</template>

<script>
import { MdsButton, MdsButtonContainer } from '@mds/button'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import CustomTablePopover from './CustomTablePopover.vue'
import MdsTooltip from '@mds/tooltip'
import isEqual from 'lodash/isEqual'
import defaultConfig from '@/config/i18n'

const exportEvent = 'export'

export default {
  name: 'CustomTableActions',
  components: {
    MdsButton,
    MdsButtonContainer,
    CustomTablePopover,
    MdsTooltip,
  },
  props: {
    record: {
      type: Object,
    },
    rowId: {
      type: Number,
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [MwcBaseHelpersMixin],

  data() {
    return {
      defaultConfig,
      tooltipStates: {},
      exportEvent,
    }
  },
  methods: {
    triggerEvent(type, event) {
      this.$emit(type, [this.record, event])
    },
    toggleTooltip(rowId, event, value) {
      if (isEqual(event, this.exportEvent)) {
        this.$set(this.tooltipStates, rowId, value)
      }
    },
  },
  computed: {
    triggerName() {
      return `triggerName-${this.rowId}`
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.custom-table {
  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: $mds-space-half-x;
    padding-right: $mds-space-1-x;
  }

  &__action {
    position: relative;
    padding: $mds-space-half-x $mds-space-three-quarter-x;

    &:last-child {
      &::after {
        display: none;
      }
    }

    &::after {
      content: '';
      position: absolute;
      width: 1px;
      height: 100%;
      right: -2px;
      top: 0;
      border: dashed 0.5px #cccccc;
    }
  }
}
.export-label {
  width: fit-content;
}
</style>
